import { DeployLayout } from "@rapid/components/flow/deploy/Layout";
import { DeploySidebarContent } from "@rapid/components/flow/deploy/Steps/Deploy/SidebarContent";
import { DeployVisualAreaContent } from "@rapid/components/flow/deploy/Steps/Deploy/VisualAreaContent";
import { ImproveModal } from "@rapid/components/flow/deploy/Steps/Improve";
import { ModelPage } from "@rapid/components/flow/deploy/Steps/Model/ModelPage";
import { ImproveContextProvider } from "@rapid/contexts/ImproveProvider";
import { DeploySteps } from "@rapid/types/flows";
import { useFlowState } from "@rapid/hooks/useFlowState";

export const WorkflowPage = () => {
    const { step } = useFlowState();

    switch (step) {
        case DeploySteps.DEPLOY:
            return (
                <DeployLayout
                    Sidebar={<DeploySidebarContent />}
                    VisualArea={<DeployVisualAreaContent />}
                />
            );
        case DeploySteps.IMPROVE:
            return (
                <ImproveContextProvider>
                    <ImproveModal />
                </ImproveContextProvider>
            );
        case DeploySteps.MODEL:
            return <ModelPage />;
        default:
            throw new Error(`Invalid step: ${step}`);
    }
};
